import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';
import { RdLocalizedNumberPipe } from '../../../pipes/rd-localized-number.pipe';

/**
 * KeyFigures Widget
 */
@Component({
  selector: 'key-figures-widget',
  templateUrl: './key-figures-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './key-figures-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeyFiguresWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  * @param rdLocalizedNumberPipe RdLocalizedNumberPipe
  */
  constructor(injector: Injector, private rdLocalizedNumberPipe: RdLocalizedNumberPipe) {
    super(injector, 'keyFigures', true);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    const self = this;//Kendo - keep it
    this.textAreaOptions = {
      change: function () {
        self.setDirtyFlag(true);
      },
      update: function (text) {
        self.widgetData.Comment = text;
      },
    };

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  public preprocessLoadedData(data) {
    data.waulbWaltFormatted = '';
    if (data.waulb) {
      data.waulbWaltFormatted += this.rdLocalizedNumberPipe.transform(data.waulb, 1, false, '', '', 0);
    }
    if (data.walt) {
      if (data.waulb) {
        data.waulbWaltFormatted += ' | ';
      }
      data.waulbWaltFormatted += this.rdLocalizedNumberPipe.transform(data.walt, 1, false, '', '', 0);
    }
    return data;
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("keyFigures", this.provideSaveObject.bind(this));
  }

  /**
   * Setup widget's layout if required
   */
  setupLayouts() {
    const fixLayouts = this.availableLayouts.length === 0 && this.currentLayout === 'default';

    if (fixLayouts) {
      this.currentLayout = 'Trad Val';
    }
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.setupLayouts();
    this.loadReflist('ref_property_type_l3');

    this.mockupData$ = this.widgetService.loadMockup('keyFigures').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('keyFigures', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Layout changed event handler
  * @param newLayout {string} New layout
   */
  public layoutChanged(newLayout: string): void {
    try {
      if (this.widgetConfig?.widgetSettings?.layoutSizeConfiguration) {
        const config = this.widgetConfig.widgetSettings.layoutSizeConfiguration[newLayout];
        if (config.x) {
          this.widgetConfig.sizeX = config.x;

        }
        if (config.y) {
          this.widgetConfig.sizeY = config.y;
        }
      }
      this.widgetConfig.widgetSettings.currentLayout = newLayout;
    } catch (e) {
      // Nothing
    }
    if (this.widgetData) {
      this.widgetData.WidgetLayout = newLayout;
    }
    this.ref.markForCheck();
  }
}
